<template>
  <div class="bet-info-wrapper"
       :class="{'bet-info': !notifications.length}">
    <div class="bet-area" v-if="!notifications.length">
      <div class="bet-info-message"
           v-if="!player.loggedIn && !bet.outcomes.length">
        <div class="message-icon">
          <i class="icon icon-info"></i>
        </div>
        <div class="message-text">
          {{'general_ticket_login_message' | translate}}
        </div>
      </div>
      <div class="bet-info-message"
           v-if="player.loggedIn && !bet.outcomes.length && !ticket.bets.length">
        <div class="message-icon">
          <i class="icon icon-info"></i>
        </div>
        <div class="message-text">
          {{'general_ticket_empty_message' | translate}}
        </div>
      </div>
      <div class="bet-info-message"
           v-if="player.loggedIn && !bet.outcomes.length && ticket.bets.length">
        <div class="message-icon">
          <i class="icon icon-info"></i>
        </div>
        <div class="message-text">
          {{'general_check_and_payin_message' | translate}}
        </div>
      </div>
      <div class="bet-item-details"
           v-if="betInfo.title && betInfo.title.length">
        <span class="bet-type">{{ betInfo.subtitle }}</span>
        <div>
          <span class="value"
                :key="index"
                v-for="(value, index) in betInfo.title">
          {{formatTitle(value.title)}}
        </span>
        </div>
      </div>
      <div class="remove-bet"
           v-if="bet && bet.outcomes.length"
           @click="clearSelection">
        <i class="icon icon-close-a"></i>
      </div>
    </div>
    <div class="notification-area"
         v-if="notifications.length"
         :class="{wide: true}">
      <div class="item" v-for="(item, key) in notifications"
           :class="item.status"
           :key="key">
        <div class="item-icon">
          <i class="icon" :class="`icon-${item.icon}`"></i>
        </div>
        <div class="item-title"
             :title="`${item.message}`">
          {{item.message | translate}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { upperFirst } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import eventBus from '@/utility/eventBus';

export default {
  name: 'BetInfoBar',
  data() {
    return {
      betInfo: {},
    };
  },
  computed: {
    ...mapGetters([
      'bet',
      'editMode',
      'selectedBet',
      'notifications',
      'ticket',
      'player',
    ]),
  },
  methods: {
    ...mapActions([
      'resetBet',
      'resetSelection',
      'resetSelectedBet',
    ]),
    clearSelection(event) {
      if (event) {
        eventBus.$emit('removeBet');
      }
      this.resetBet();
      this.resetSelection();
      this.resetSelectedBet();
    },
    formatTitle(value) {
      if (typeof value === 'string') {
        let transValue = this.$options.filters.translate(value);
        transValue = transValue.toLowerCase();
        return upperFirst(transValue);
      }
      return value;
    },
  },
  watch: {
    editMode(edit) {
      if (!edit) {
        this.clearSelection();
      }
    },
    'bet.outcomes': function () {
      this.betInfo = this.bet;
    },
    selectedBet(value) {
      if (value.title) {
        this.betInfo = value;
      }
    },
    bet(value) {
      this.betInfo = value;
    },
  },
};
</script>

<style lang="scss" scoped>
  .bet-info-wrapper {
    width: 100%;
    float: left;
    line-height: 40px;
    border-radius: 2px;
    color: var(--text-primary-1);
    background-color: var(--bet-info-bar, var(--bg-color-1));

    &.bet-info {
      padding: 0 10px;
    }

    .notification-area {
      float: left;
      width: 100%;
      height: 100%;
      font-size: 14px;
      cursor: default;

      .item {
        height: 100%;
        line-height: 1.5;
        padding: 0 10px;
        color: var(--text-primary-1);
        border-radius: 2px;

        &.info {
          background: var(--brand-bg);
          color: var(--brand-text-color, var(--text-primary-1));
        }

        &.resolving {
          background: var(--system-neutral);
          color: var(--system-neutral-text-color);
        }

        &.success, &.closed {
          background: var(--system-positive);
          color: var(--text-primary-1);
        }

        &.error, &.rejected {
          background: var(--system-negative);
          color: var(--system-positive-text-color, var(--text-primary-1));
        }

        .item-icon {
          height: 100%;
          float: left;
          line-height: 42px;
        }

        .item-title {
          margin-left: 10px;
          float: left;
          width: 90%;
          height: 100%;
          overflow: hidden;
          padding: 10px 0;
          text-align: left;
        }
      }
    }

    .bet-area {
      float: left;
      width: 100%;
      height: 100%;
      .bet-info-message {
        float: left;
        height: 100%;
        width: 100%;
        font-size: 12px;
        color: var(--text-primary-3);
        display: flex;
        justify-content: flex-start;

        .message-icon {
          padding: 0 7px 0 0;
          margin-right: 7px;
        }

        .message-text {
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: left;
        }

        .message-icon, .message-text {
          float: left;
        }
      }

      .bet-item-details {
        float: left;
        height: 100%;
        font-size: 14px;
        line-height: 1.3;

        .bet-type {
          font-size: 12px;
          color: var(--text-primary-3);
        }

        .value {
          margin-right: 8px;
        }
      }

      .remove-bet {
        float: right;
        cursor: pointer;
      }
    }
  }
</style>
